<section id="chipchecker" class="chip-checker position-relative overflow-hidden">
  <div class="container position-relative z-1 py-5">
    <div class="chip-checker__card px-4 py-5">

      <h2 class="chip-checker__title display-3 d-lg-none">Check a chip</h2>

      <h3 class="chip-checker__heading display-3">Not sure which database holds your pet's details?</h3>

      <p class="chip-checker__body">
        Enter your pet's microchip number and we'll tell you right away; for free.
      </p>

      <div *ngIf="chipCheckerResults" class="chip-checker__results p-3 mb-3">
        <p [class]="'chip-checker__results-message mb-1 text-' + chipCheckerResults.type">
          {{ chipCheckerResults.message }}
        </p>
        <p *ngIf="chipCheckerResults.type === 'success'" class="mb-0">
          <a
            *ngFor="let link of chipCheckerResults.links; let last = last"
            [href]="link"
            target="_blank"
            class="chip-checker__result-link">
            {{ link }}<span *ngIf="!last">,<br></span>
          </a>
        </p>
      </div>

      <form #chipCheckerForm="ngForm" (ngSubmit)="checkChip()" novalidate>

        <div class="form-check mb-3">
          <input
            #checkChipAgree="ngModel"
            type="checkbox"
            class="form-check-input chip-checker__checkbox"
            id="checkChipAgree"
            name="checkChipAgree"
            ngModel=""
            required>
          <label class="form-check-label chip-checker__checkbox-label" for="checkChipAgree">
            By using this lookup you consent to identi storing your IP address, which identi
            will use solely for pet reuniting purposes.
          </label>
        </div>

        <div class="d-flex flex-column flex-lg-row gap-2">
          <input
            #checkChipNumber="ngModel"
            type="text"
            class="form-control chip-checker__input h-auto"
            placeholder="Enter 15-digit microchip number"
            id="checkChipNumber"
            name="checkChipNumber"
            [(ngModel)]="chipCheckerNumber"
            [disabled]="chipCheckerLoading"
            required>
          <button
            type="submit"
            class="chip-checker__btn btn ui-btn ui-btn--primary fw-bold"
            [disabled]="!chipCheckerForm.valid || chipCheckerLoading">
            <fa-icon
              *ngIf="chipCheckerLoading"
              [icon]="['fas', 'spinner']"
              [animation]="'spin'"
              class="me-2">
            </fa-icon>
            {{ chipCheckerLoading ? 'Checking...' : 'Check now' }}
          </button>
        </div>

      </form>
    </div>
  </div>

  <app-background-icon
    src="/assets/images/icons/ball-cream.svg"
    [top]="20"
    [left]="15"
    [width]="150"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/toy-cream.svg"
    [top]="14"
    [left]="84"
    [width]="150"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/dog-cream.svg"
    [top]="80"
    [left]="85"
    [width]="150"
    [opacity]="0.5"
  />
</section>
